import { SxProps, Theme } from '@mui/material';

type TStyles = {
  container: SxProps<Theme>;
};

export const styles: TStyles = {
  container: {
    width: { xs: 140, sm: 180, md: 200 },
    height: { xs: 140, sm: 180, md: 200 },
    p: 1.25,
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
};
